import { injectPrimitive } from '../../../../common/store/base/injectPrimitive';
import { IApplicationRequirementService } from '../../../../service/applicationRequirement/entity/IApplicationRequirementService';
import { RestApplicationRequirementService } from '../../../../service/applicationRequirement/entity/RestRequirementService';
import { CRUDServiceType } from '../../../../service/common/service/CRUDServiceType';
import { IApplicationDataModel } from '../../../../service/application/data/IApplicationDataModel';
import { IApplicationModel } from '../../../../service/application/entity/IApplicationModel';
import { IApplicationRequirementEntity } from '../../../../service/applicationRequirement/entity/IApplicationRequirementModel';
import { IProjectModel } from '../../../../service/project/IProjectModel';
import { IRequirementModel } from '../../../../service/requirement/entity/IRequirementModel';
import { ServiceType, injectRootService } from '../../../../service/RootServiceFactory';
import { UserSystemRoleModelPermissionMap } from '../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { LayoutNotificationType } from '../../../../view/layout/common/notification/store/ILayoutNotification';
import { IMainLayoutDomainStore } from '../../../../view/layout/main/store/domain/IMainLayoutDomainStore';
import { RiskManagerReportRootService } from '../../service/report/RiskManagerReportService';
import { RiskManagerRootService } from '../../service/RiskManagerRootService';
import { RiskManagerSystemRolePermissions } from '../../systemRole/RiskManagerSystemRoleExtensions';
import { IRiskManagerProjectInfoDomain } from '../../view/projectRiskInfo/domain/IRiskManagerProjectInfoDomain';
import { IRiskManagerRequirementThreatLinkModel } from '../../service/requirement/IRiskManagerRequirementThreatLinkModel';
import { IRiskManagerDataModel } from '../../service/manager/data/IRiskManagerDataModel';
import { RiskManagerQuestionFieldRelationType } from '../../service/question/field/RiskManagerQuestionFieldRelationType';

export class RiskManagerReportDomain {
  constructor(
    public rootDomain: IRiskManagerProjectInfoDomain,
    private layoutDomain: IMainLayoutDomainStore,
    private riskManagerService = new RiskManagerRootService('admin'),
    private riskManagerReportRootService = new RiskManagerReportRootService(),
    public coreRootService = injectRootService(ServiceType.admin),
    public isHaveAccessAndReport = injectPrimitive(false),
    private applicationRequirementService: IApplicationRequirementService = new RestApplicationRequirementService(CRUDServiceType.admin),
  ) { }

  async setAccessToProjectReport(projectId: string, layoutDomain?: any, rowStatus?: boolean) {
    let rowContextChecker = false;
    if (layoutDomain) {
      rowContextChecker = layoutDomain.userHaveAnyAccess([
        RiskManagerSystemRolePermissions[
        'extension-risk-manager-settings-report'
        ] as unknown as UserSystemRoleModelPermissionMap,
      ]);
    }

    if (rowContextChecker || this.isCanViewReports()) {
      if (rowStatus !== undefined) {
        this.isHaveAccessAndReport.setValue(rowStatus);
      } else {
        const riskManagerData = this.rootDomain.riskManagersData.list.find(
          (riskManagerData) => riskManagerData.targetId === projectId,
        );
        this.isHaveAccessAndReport.setValue(!!riskManagerData);
      }
    }
  }

  isCanViewReports() {
    const isCanViewReports = this.layoutDomain.userHaveAnyAccess([
      RiskManagerSystemRolePermissions[
      'extension-risk-manager-settings-report'
      ] as unknown as UserSystemRoleModelPermissionMap,
    ]);

    return isCanViewReports;
  }

  async downloadRiskManagerJson(projectId: string) {
    const riskManagerData = (
      await this.riskManagerService.manager.data.search({
        limit: 1,
        filter: { targetId: { equal: projectId } },
        fields: ['isComplete', 'id']
      })
    ).data[0];

    if (!riskManagerData.isComplete) {
      this.layoutDomain.notifications.showNotification({
        type: LayoutNotificationType.warning,
        text: `JSON не может выгружен. Не все ответы для анкеты рисков заполнены.`,
      });
      return;
    }
    const jsonData = await this.riskManagerReportRootService.report.getJsonReport(projectId)

    const project = await this.coreRootService.project.entity.getById(projectId);
    const projectApplications = (
      await this.coreRootService.application.entity.search({
        filter: { projectId: { equal: project?.id || '' } },
      })
    ).data;
    const projectApplicationsData = (
      await this.coreRootService.application.data.search({
        filter: {
          ids: {
            in: projectApplications.map((item) => item.dataId || ''),
          },
        },
      })
    ).data;
    const applicationRequirement: IApplicationRequirementEntity[] = [];
    for (let app of projectApplicationsData) {
      const appReqs = await this.applicationRequirementService.getAppReqByAppId(app.id || '');
      applicationRequirement.push(...appReqs);
    }

    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(JSON.stringify(jsonData))}`;
    const link = document.createElement('a');
    link.href = jsonString;
    link.download = `${jsonData?.project?.name} - Анкета Рисков.json`;
    link.click();
  }
}